export default __webpack_public_path__ + "static/media/video5.4ffefd50.mp4";